import { useAtomValue } from "jotai"

import { showAdjustingBrushCursorAtom, showingHealingPanelAtom } from "@/store/ui-views-state"
import { BrushMaskControls } from "@/components/Masking/BrushMaskControls"
import { HealingControls } from "./HealingControls"
import { isHealingHoverAtom, isHealingPreviewEnabledAtom } from "../../store/editor/healing-state"
import { photoLoadingStateAtom } from "@/store/editor/photo-loading"
import { currentHoverPreviewAtom } from "@/store/editor/photo-preview"
import { showingMaskingToolsOverlayAtom } from "@/store/editor/masks-state"

const HEALING_ADJUSTING_CURSOR_CENTER_OFFSET = 150

export const HealingToolsOverlay = () => {
	const isActive = useAtomValue(showingHealingPanelAtom)
	const isHealingPreviewEnabled = useAtomValue(isHealingPreviewEnabledAtom)
	const isHover = useAtomValue(isHealingHoverAtom)
	const isPointerInsideEditor = useAtomValue(showingMaskingToolsOverlayAtom)
	const loadingState = useAtomValue(photoLoadingStateAtom)
	const showingHistory = useAtomValue(currentHoverPreviewAtom)
	const showAdjustingBrushCursor = useAtomValue(showAdjustingBrushCursorAtom)

	if (!isActive) {
		return null
	}

	if (!isHealingPreviewEnabled) {
		return null
	}

	// select source UI
	return (
		<BrushMaskControls
			hidden={false}
			hideCursor={!showAdjustingBrushCursor && (isHover || !isPointerInsideEditor)}
			cursorDrawPosition={
				showAdjustingBrushCursor
					? ({ width }) => ({
							x: width - HEALING_ADJUSTING_CURSOR_CENTER_OFFSET,
							y: HEALING_ADJUSTING_CURSOR_CENTER_OFFSET,
						})
					: undefined
			}
		>
			{!showingHistory && loadingState === "loaded" && <HealingControls />}
		</BrushMaskControls>
	)
}
